import axios from "axios";

import config from "../../config/config";
import { getToken } from "../../common";

export const updateAPIEndpointAPI = async ({
  id,
  method,
  description,
  path,
  isEnabled,
}) => {
  const payload = {
    method,
    description,
    path,
    isEnabled,
  };

  return await axios({
    method: "put",
    url: `${config.api.base_url}api-keys/endpoints/${id}`,
    data: payload,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: getToken(),
    },
  });
};

export default updateAPIEndpointAPI;
